module.exports = __webpack_public_path__ + "static/media/imgn-mision.1bb1d345.jpg";